import { render, staticRenderFns } from "./IconSort.vue?vue&type=template&id=0f9bfa96&scoped=true&"
import script from "./IconSort.vue?vue&type=script&lang=js&"
export * from "./IconSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9bfa96",
  null
  
)

export default component.exports